// Generated by ReScript, PLEASE EDIT WITH CARE

import * as LumiReact from "lumi-rescript/lib/es6/src/LumiReact.res.js";
import * as LumiRequest from "lumi-rescript/lib/es6/src/LumiRequest.res.js";
import * as Spinner$Web from "lumi-web/lib/es6/src/Spinner.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as LumiReactReducer from "lumi-rescript/lib/es6/src/LumiReactReducer.res.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Document$LumiStore from "lumi-store/lib/es6/src/Document.res.js";
import * as RescriptReactRouter from "@rescript/react/lib/es6/src/RescriptReactRouter.res.js";
import * as API$LumiAuthentication from "./API.res.js";
import * as I18n$LumiAuthentication from "./I18n.res.js";
import * as APIKeyLogin$LumiAuthentication from "./APIKeyLogin.res.js";
import * as GlobalState$LumiAuthentication from "./GlobalState.res.js";
import * as PasswordLogin$LumiAuthentication from "./PasswordLogin.res.js";
import * as PasswordReset$LumiAuthentication from "./PasswordReset.res.js";
import * as PasswordForgotten$LumiAuthentication from "./PasswordForgotten.res.js";

import '../../../src/css/main.scss'
;

function checkServerError(error, toAuth) {
  if (typeof error !== "object") {
    if (error === "NoXSRFTokenCookie") {
      return toAuth("HandleUnauthorized");
    } else {
      return;
    }
  } else if (error.TAG === "ServerError" && error.status === 401) {
    return toAuth("HandleUnauthorized");
  } else {
    return;
  }
}

let default_rev = {
  revNum: Document$LumiStore.RevNum.beforeFirst,
  createTime: new Date(0),
  body: {
    deleted: false,
    labelsHash: undefined,
    labels: undefined,
    ext: {
      owner: "",
      author: ""
    },
    contents: {
      email: undefined,
      name: "Placeholder account"
    }
  }
};

let $$default = {
  key: "",
  rev: default_rev
};

let Account = LumiReact.Context.Make({
  $$default: $$default
});

function $$default$1(param) {
  
}

let Dispatch = LumiReact.Context.Make({
  $$default: $$default$1
});

function Barrier(props) {
  let __forceAPIKey = props.forceAPIKey;
  let forceAPIKey = __forceAPIKey !== undefined ? __forceAPIKey : false;
  let match = LumiReactReducer.useReducer(() => {
    let url = RescriptReactRouter.dangerouslyGetInitialUrl(undefined, undefined);
    let apiKey = APIKeyLogin$LumiAuthentication.apiKeyFromUrl(url);
    if (forceAPIKey) {
      return {
        TAG: "Init",
        _0: {
          TAG: "APIKeyLogin",
          apiKey: Stdlib_Option.getOr(apiKey === null ? undefined : Primitive_option.some(apiKey), "")
        }
      };
    }
    let passwordResetLock = PasswordReset$LumiAuthentication.passwordResetLockFromUrl(url);
    if (passwordResetLock !== undefined) {
      return {
        TAG: "Init",
        _0: {
          TAG: "PasswordReset",
          accountId: passwordResetLock[0],
          secret: passwordResetLock[1]
        }
      };
    } else if (apiKey !== null) {
      return {
        TAG: "Init",
        _0: {
          TAG: "APIKeyLogin",
          apiKey: apiKey
        }
      };
    } else {
      return {
        TAG: "InitWithEffect",
        _0: "GettingAccount",
        _1: param => {
          let dispatch = param.dispatch;
          return LumiRequest.resultFutureEffect(API$LumiAuthentication.getAccount(), account => dispatch({
            TAG: "Authenticated",
            _0: account
          }), err => dispatch({
            TAG: "GetAccountFailed",
            _0: err
          }));
        }
      };
    }
  }, undefined, (_state, action) => {
    if (typeof action !== "object") {
      switch (action) {
        case "PerformLogout" :
          return {
            TAG: "Effect",
            _0: param => {
              let dispatch = param.dispatch;
              return LumiRequest.resultFutureEffect(API$LumiAuthentication.cookieLogout(), () => dispatch("LogoutSucceeded"), prim => {
                console.error(prim);
              });
            }
          };
        case "LogoutSucceeded" :
          return {
            TAG: "Update",
            _0: {
              TAG: "PasswordLogin",
              initialEmail: "",
              initialError: undefined
            }
          };
        case "HandleUnauthorized" :
          let url = RescriptReactRouter.dangerouslyGetInitialUrl(undefined, undefined);
          let apiKey = APIKeyLogin$LumiAuthentication.apiKeyFromUrl(url);
          if (forceAPIKey) {
            return {
              TAG: "Update",
              _0: {
                TAG: "APIKeyLogin",
                apiKey: Stdlib_Option.getOr(apiKey === null ? undefined : Primitive_option.some(apiKey), "")
              }
            };
          } else if (apiKey !== null) {
            return {
              TAG: "Update",
              _0: {
                TAG: "APIKeyLogin",
                apiKey: apiKey
              }
            };
          } else {
            return {
              TAG: "UpdateWithEffect",
              _0: {
                TAG: "PasswordLogin",
                initialEmail: "",
                initialError: "PhraseNotLoggedIn"
              },
              _1: param => {
                GlobalState$LumiAuthentication.deleteXSRFTokenCookie();
              }
            };
          }
      }
    } else {
      switch (action.TAG) {
        case "Authenticated" :
          return {
            TAG: "Update",
            _0: {
              TAG: "LoggedIn",
              _0: action._0
            }
          };
        case "GetAccountFailed" :
          let err = action._0;
          console.log("getAccount returned an error: ", err);
          let tmp;
          tmp = typeof err !== "object" ? (
              err === "NoXSRFTokenCookie" ? undefined : I18n$LumiAuthentication.entryFromApiError(err)
            ) : (
              err.TAG === "ServerError" && err.status === 401 ? undefined : I18n$LumiAuthentication.entryFromApiError(err)
            );
          return {
            TAG: "Update",
            _0: {
              TAG: "PasswordLogin",
              initialEmail: "",
              initialError: tmp
            }
          };
        case "ShowPasswordLogin" :
          return {
            TAG: "Update",
            _0: {
              TAG: "PasswordLogin",
              initialEmail: action.initialEmail,
              initialError: action.initialError
            }
          };
        case "ShowPasswordForgotten" :
          return {
            TAG: "Update",
            _0: {
              TAG: "PasswordForgotten",
              initialEmail: action.initialEmail,
              initialError: action.initialError
            }
          };
      }
    }
  });
  let dispatch = match[1];
  let state = match[0];
  if (typeof state !== "object") {
    return JsxRuntime.jsx(Spinner$Web.make, {});
  }
  switch (state.TAG) {
    case "APIKeyLogin" :
      return JsxRuntime.jsx(APIKeyLogin$LumiAuthentication.make, {
        apiKey: state.apiKey,
        forceAPIKey: forceAPIKey,
        toParent: dispatch
      });
    case "PasswordLogin" :
      return JsxRuntime.jsx(PasswordLogin$LumiAuthentication.make, {
        initialEmail: state.initialEmail,
        initialError: state.initialError,
        toParent: dispatch
      });
    case "PasswordForgotten" :
      return JsxRuntime.jsx(PasswordForgotten$LumiAuthentication.make, {
        initialEmail: state.initialEmail,
        initialError: state.initialError,
        toParent: dispatch
      });
    case "PasswordReset" :
      return JsxRuntime.jsx(PasswordReset$LumiAuthentication.make, {
        accountId: state.accountId,
        secret: state.secret,
        toParent: dispatch
      });
    case "LoggedIn" :
      return JsxRuntime.jsx(Dispatch.Provider.make, {
        value: dispatch,
        children: JsxRuntime.jsx(Account.Provider.make, {
          value: state._0,
          children: props.children
        })
      });
  }
}

let make = Barrier;

export {
  checkServerError,
  Account,
  Dispatch,
  make,
}
/*  Not a pure module */
